import Box from "@mui/material/Box";
import { BodyTextM, HeadingM } from "@repo/ui";
import { type FC } from "react";
import { TriggerButton } from "../Link";
import { useDrawer } from "./context";
import { SingleStepDrawer } from "./SingleStepDrawer";

interface InfoIconDrawerProps {
	title?: string;
	description?: string | JSX.Element;
	bottomButtonAction?: () => void;
	dataTest?: string;
}

const InfoIconDrawer: FC<InfoIconDrawerProps> = ({
	title,
	description,
	bottomButtonAction,
	dataTest,
}) => {
	const { hideDrawer } = useDrawer();
	return (
		<SingleStepDrawer dataTest={dataTest}>
			<HeadingM withoutScale>{title}</HeadingM>
			<BodyTextM>{description}</BodyTextM>
			<Box
				sx={{
					display: "flex",
					justifyContent: "flex-end",
					mt: 6,
				}}
			>
				<TriggerButton
					onClick={bottomButtonAction ? bottomButtonAction : hideDrawer}
				>
					Rozumím
				</TriggerButton>
			</Box>
		</SingleStepDrawer>
	);
};

export default InfoIconDrawer;
